import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { ToastContainer } from 'react-toastify';
import { ProductSearchResults } from './search-results';
import { CustomerContextProvider } from '../../../context/customer-context';

export function initProductSearchResults() {
  document.getElementsByName('product-search-results-v2').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, locationId, userId, sessionId, isUserLoggedIn, keyword, categoryId, ...props } =
        Object.assign({}, element.dataset) as any;
      const catId = categoryId !== 'null' ? parseInt(categoryId) : undefined;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <ToastContainer />
              <ProductSearchResults
                locationId={locationId}
                user={{ userId: userId ? userId : undefined, sessionId, isLoggedIn: isUserLoggedIn === '1' }}
                keyword={keyword}
                categoryId={catId}
                {...props}
              />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
